import { render, staticRenderFns } from "./text-stats-widget.vue?vue&type=template&id=54815060"
import script from "./text-stats-widget.vue?vue&type=script&lang=ts"
export * from "./text-stats-widget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports